import mixpanel from "mixpanel-browser"
import { User } from "../types/User"
import { isExcludedEmail } from "../utils/email"
import { isProduction } from "../utils/general"

export const updateMixpanelUser = (user: User) => {
  if (!user.email || !isProduction || isExcludedEmail(user.email)) {
    return
  }

  mixpanel.identify(user.uid)
  mixpanel.people.set({ $name: user.name, $email: user.email })
}
